import { ProjectComponent } from './project.component';
import { ProjectService } from '@fuse/services/project.service';
const ɵ0 = ProjectService;
const routes = [
    {
        path: 'project/:id',
        component: ProjectComponent,
        pathMatch: 'full',
        resolve: {
            data: ɵ0
        }
    }
];
export class ProjectModule {
}
export { ɵ0 };
